var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.404,
    height: 70.428,
    viewBox: "0 0 70.404 70.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "confetti",
    transform: "translate(-0.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(0.082 16.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M48.092,140.993a1.173,1.173,0,1,0-2.208.8l.017.045c1.07,2.793,1.148,4.928.211,5.867-1.136,1.133-3.965.779-7.569-.946a50.188,50.188,0,0,1-12.988-9.692c-9.191-9.192-12.983-18.212-10.638-20.557a3.205,3.205,0,0,1,2.654-.62,1.173,1.173,0,0,0,.228-2.335,5.4,5.4,0,0,0-4.541,1.291c-4.3,4.3,2.273,15.509,10.638,23.875a52.476,52.476,0,0,0,13.634,10.148A23.119,23.119,0,0,0,40.361,150l-8.337,3.161a33.212,33.212,0,0,1-21-25.865,1.173,1.173,0,1,0-2.319.364,35.524,35.524,0,0,0,20.151,26.7L15.133,159.55a1.152,1.152,0,0,0-.235-.279,16.348,16.348,0,0,1-6.054-11.362L8.3,141.316a1.159,1.159,0,0,0-1.234-1.079l-.036,0A1.173,1.173,0,0,0,5.952,141.5s0,.005,0,.008l.554,6.591a18.691,18.691,0,0,0,6.208,12.361l-9.788,3.705,1.76-7.223a1.174,1.174,0,0,0-2.281-.556L.116,165.775a1.173,1.173,0,0,0,1.556,1.376l43.414-16.427a1.094,1.094,0,0,0,.195-.122,4.558,4.558,0,0,0,2.491-1.243C48.934,148.2,49.935,145.8,48.092,140.993Z",
    transform: "translate(-0.082 -113.468)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(34.14 38.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M257.318,266.234a38.639,38.639,0,0,0-19.88-1.93l-4.192.7a1.173,1.173,0,0,0,.387,2.314l4.191-.7a36.266,36.266,0,0,1,18.67,1.814,1.208,1.208,0,0,0,.412.069,1.173,1.173,0,0,0,.412-2.273Z",
    transform: "translate(-232.294 -263.781)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(36.462 22.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M275,152.666a1.173,1.173,0,0,0-1.564-.555l-24.64,11.734a1.173,1.173,0,0,0-.555,1.564h0a1.173,1.173,0,0,0,1.564.555h0l24.64-11.733A1.173,1.173,0,0,0,275,152.666Z",
    transform: "translate(-248.126 -151.997)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(22.742 7.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M160.414,48.827a1.173,1.173,0,1,0-2.3.467c0,.014.006.028.009.042a32.822,32.822,0,0,1-1.752,19.84l-1.706,4.094a1.173,1.173,0,0,0,.63,1.53,1.156,1.156,0,0,0,.451.09,1.173,1.173,0,0,0,1.083-.722l1.707-4.089A35.154,35.154,0,0,0,160.414,48.827Z",
    transform: "translate(-154.576 -47.887)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(61.1 42.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M419.625,288a3.52,3.52,0,1,0,3.52,3.52A3.52,3.52,0,0,0,419.625,288Zm0,4.693a1.173,1.173,0,1,1,1.173-1.173A1.173,1.173,0,0,1,419.625,292.693Z",
    transform: "translate(-416.105 -288)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(32.939 9.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M227.625,64a3.52,3.52,0,1,0,3.52,3.52A3.52,3.52,0,0,0,227.625,64Zm0,4.693A1.173,1.173,0,1,1,228.8,67.52,1.173,1.173,0,0,1,227.625,68.693Z",
    transform: "translate(-224.105 -64)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(23.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.347,
    cy: 2.347,
    r: 2.347,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(57.58 5.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M393.278,40a1.173,1.173,0,0,0-1.173,1.173v1.173a1.173,1.173,0,1,0,2.347,0V41.173A1.173,1.173,0,0,0,393.278,40Z",
    transform: "translate(-392.105 -40)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(57.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M393.278,0a1.173,1.173,0,0,0-1.173,1.173V2.347a1.173,1.173,0,1,0,2.347,0V1.173A1.173,1.173,0,0,0,393.278,0Z",
    transform: "translate(-392.105)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(59.926 3.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M410.452,24h-1.173a1.173,1.173,0,0,0,0,2.347h1.173a1.173,1.173,0,0,0,0-2.347Z",
    transform: "translate(-408.105 -24)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(54.06 3.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M370.452,24h-1.173a1.173,1.173,0,0,0,0,2.347h1.173a1.173,1.173,0,0,0,0-2.347Z",
    transform: "translate(-368.105 -24)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(43.475 12.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M303,87.832H297.11a1.173,1.173,0,0,0-1.173,1.173V94.9a1.173,1.173,0,0,0,1.173,1.173H303a1.173,1.173,0,0,0,1.173-1.173V89.005A1.173,1.173,0,0,0,303,87.832Zm-1.173,5.891h-3.545V90.179h3.545Z",
    transform: "translate(-295.937 -87.832)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(28.246 22.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M205.853,152.476a1.173,1.173,0,0,0-1.624-.085L192.5,162.952a1.173,1.173,0,0,0,1.57,1.744l11.734-10.56A1.173,1.173,0,0,0,205.853,152.476Z",
    transform: "translate(-192.107 -152.105)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(62.273 26.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M425.278,184a1.173,1.173,0,0,0-1.173,1.173v1.173a1.173,1.173,0,1,0,2.347,0v-1.173A1.173,1.173,0,0,0,425.278,184Z",
    transform: "translate(-424.105 -184)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(65.607 25.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M449.654,175.881l-.83-.83a1.173,1.173,0,0,0-1.659,1.659l.83.83a1.173,1.173,0,0,0,1.659-1.659Z",
    transform: "translate(-446.836 -174.722)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(66.966 22.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M458.452,152h-1.173a1.173,1.173,0,0,0,0,2.347h1.173a1.173,1.173,0,0,0,0-2.347Z",
    transform: "translate(-456.105 -152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(65.593 18.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M449.542,124.148a1.174,1.174,0,0,0-1.63,0l-.83.83a1.173,1.173,0,0,0,.83,2h0a1.173,1.173,0,0,0,.83-.344l.83-.83A1.173,1.173,0,0,0,449.542,124.148Z",
    transform: "translate(-446.739 -123.818)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(62.273 16.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M425.278,112a1.173,1.173,0,0,0-1.173,1.173v1.173a1.173,1.173,0,1,0,2.347,0v-1.173A1.173,1.173,0,0,0,425.278,112Z",
    transform: "translate(-424.105 -112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(58.138 18.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M398.734,124.977l-.83-.83a1.173,1.173,0,0,0-1.659,1.659l.83.83a1.173,1.173,0,0,0,1.659-1.659Z",
    transform: "translate(-395.916 -123.818)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(0.084 0.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M14.119,5.381a1.173,1.173,0,0,0-.947-.8l-3.444-.5L8.193.963a1.221,1.221,0,0,0-2.1,0L4.545,4.083l-3.444.5a1.173,1.173,0,0,0-.652,2L2.939,9.013l-.587,3.43a1.173,1.173,0,0,0,1.7,1.241l3.08-1.624,3.08,1.619a1.173,1.173,0,0,0,1.7-1.237l-.587-3.43,2.492-2.429A1.173,1.173,0,0,0,14.119,5.381ZM9.249,7.763A1.173,1.173,0,0,0,8.911,8.8L9.2,10.5l-1.519-.8a1.174,1.174,0,0,0-1.091,0l-1.525.8.291-1.7a1.173,1.173,0,0,0-.332-1.036l-1.233-1.2,1.7-.248a1.173,1.173,0,0,0,.884-.642l.759-1.541L7.9,5.674a1.173,1.173,0,0,0,.882.642l1.7.248Z",
    transform: "translate(-0.095 -0.361)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(52.914 50.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M373.9,352.386h0l-.483-.725a17.707,17.707,0,0,0-11.782-7.619,1.173,1.173,0,0,0-.387,2.314,15.351,15.351,0,0,1,8.954,4.991,6.922,6.922,0,0,0-4.693,3.223,4.693,4.693,0,1,0,8.2,4.576,6.805,6.805,0,0,0,.762-3.012,5.733,5.733,0,0,1,.257,6.093,1.173,1.173,0,1,0,2.018,1.2c.011-.018.021-.036.03-.054A8.191,8.191,0,0,0,373.9,352.386ZM371.656,358a2.347,2.347,0,0,1-4.109-2.268l.011-.019a4.4,4.4,0,0,1,3.177-2.067,1.193,1.193,0,0,1,.587.136C372.312,354.336,372.365,356.733,371.656,358Z",
    transform: "translate(-360.294 -344.031)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerIcon4);
export default __webpack_public_path__ + "static/media/career_icon_4.2c989d1fd8b23cd3264f16d742ccbe56.svg";
export { ForwardRef as ReactComponent };